'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.VersionFormatter = VersionFormatter;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('./index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Provides a formatted version, with an optional prefix.
 *
 * @example
 * import { VersionFormatter } from '@ta-interaktiv/react-publication-date'
 *
 * function Component (props) {
 *   return (
 *     <VersionFormatter version='1.0.0' />
 *   )
 * }
 *
 * @param {object} props
 * @param {number} props.version A semantic version string. If not provided, the element will not render.
 * @param {string} [props.prefix=Version] A string that precedes the version.
 *
 * @see {@link NameValueItem} for additional `className` props that can be passed in.
 */
function VersionFormatter(props) {
  var version = props.version,
      _props$prefix = props.prefix,
      prefix = _props$prefix === undefined ? 'Version' : _props$prefix;

  if (version) {
    return _react2.default.createElement(_index.NameValueItem, _extends({}, props, { name: prefix, value: version }));
  } else {
    return null;
  }
}

exports.default = VersionFormatter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-publication-info/dist/version-formatter.js
// module id = 464
// module chunks = 0